<template>
    <div v-if="targetImage" class="d-flex flex-column m-3">
        <div class="d-flex flex-row justify-content-between no-select">
            <div style="color: #1976d2" class="d-flex flex-row flex-fill justify-content-center">
                <div>
                    <i style="font-size: 1rem" class="el-icon-download"></i>
                </div>
                <div>
                    <span class="pop-up-title">{{ $t('downloadRemoteDesktopModal.title') }}</span>
                </div>
            </div>
            <button type="button" @click="closeThisPopup">
                <i style="font-size: 1.75rem" class="el-icon-close button-close-popup"></i>
            </button>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('downloadRemoteDesktopModal.tabRemoteDesktop')" :name="connectToImageTab.REMOTE_DESKTOP">
                <RemoteDesktop :targetImage="targetImage" @processingEvent="processingEvent" />
            </el-tab-pane>
            <!-- <el-tab-pane
        :disabled="
          !(
            targetImage.canConnect &&
            targetImage.remoteAddress &&
            targetImage.sshPort
          )
        "
        label="Remote SSH"
        :name="connectToImageTab.SSH"
        >Remote SSH</el-tab-pane
      > -->
            <!-- <el-tab-pane label="Parsec Prime" :name="connectToImageTab.PARSEC_PRIME"
                v-if="isParsecPrimeActived">
                <ParsecPrime @processingEvent="processingEvent" />
            </el-tab-pane> -->
            <el-tab-pane :label="$t('downloadRemoteDesktopModal.tabOtherSoftware')" :name="connectToImageTab.OTHER_SOFTWARE">
                <OtherSoftware @processingEvent="processingEvent" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import api from '@/api/baseApi';
    // component
    import RemoteDesktop from "@/views/component/RentalService/RemoteDesktop";
    //import ParsecPrime from "@/views/component/RentalService/ParsecPrime";
    import OtherSoftware from "@/views/component/RentalService/OtherSoftware";

    // Constant
    import {
        POPUP_ID
    } from "@/constant/baseConstant";
    import {
        CONNECT_TO_IMAGE_TAB
    } from "@/constant/rental";
    import {
        SETTINGS_USER_API
    } from "@/constant/apiSettings";

    // Extend
    import base from "@/scripts/base";

    export default {
        extends: base,

        components: {
            RemoteDesktop,
            //ParsecPrime,
            OtherSoftware,
        },

        data() {
            return {
                connectToImageTab: CONNECT_TO_IMAGE_TAB,
                activeName: CONNECT_TO_IMAGE_TAB.REMOTE_DESKTOP,
                isParsecPrimeActived: false,
            };
        },

        props: {
            targetImage: {
                type: Object,
                default: null,
            },
        },
        watch: {
            targetImage: {
                handler: function() {
                    //this.getInfo();
                },
                deep: false
            }
        },
        mounted() {            
            //this.getInfo();
        },
        methods: {
            // getInfo() {
            //     api.baseRequest(SETTINGS_USER_API.IS_PARSEC_PRIME_ACTIVED, null, ``)
            //         .then((res) => {
            //             this.isParsecPrimeActived = res.data;
            //         })
            //         .catch(error => {
            //             this.processCatchApiRequest(error, "getInfo parsec Prime failed ...")
            //         });
            // },
            //#region Close this pop-up
            closeThisPopup() {
                this.closePopup(POPUP_ID.DOWNLOAD_REMOTE_DESKTOP);
            },
            //#endregion

            //#region Processing event
            processingEvent(param) {
                this[param.event](param.data);
            },
            //#endregion
        },
    };
</script>